import React, { Component } from 'react';
import moment from 'moment';
import { Slider } from 'antd';
import { Icon } from 'antd';
import {
  MinMaxWrap,
  Min,
  Max,
  ModaWrapper,
  TitleGrid,
  FilterType,
  ResetLink,
  SliderComponent,
  BottomWrapper,
  CloseText,
  FilterTriangle,
} from './styles';
import MultiSelect from '../../Components/MultiSelect/MultiSelect';
import Input from '../Input/Input';
import PropTypes from 'prop-types';

function amountFormatter(value) {
  return `$${Number(value).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}

function createModal(filters, activeFilter, activeId, selected, typed) {
  let min = Math.floor(filters[activeId].minRange);
  let max = Math.ceil(filters[activeId].maxRange);
  if (activeFilter === 'Balance') {
    return (
      <React.Fragment>
        <SliderComponent disabled={min === -1}>
          {min === -1 ? (
            <Slider
              range
              min={min}
              max={max}
              tooltipVisible={false}
              disabled={min === -1}
              defaultValue={[
                filters[activeId].selectedMin
                  ? filters[activeId].selectedMin
                  : min,
                filters[activeId].selectedMax
                  ? filters[activeId].selectedMax
                  : max,
              ]}
              key={'balance'}
            />
          ) : (
            <Slider
              range
              min={min}
              max={max}
              step={1}
              tipFormatter={amountFormatter}
              tooltipPlacement='top'
              defaultValue={[
                filters[activeId].selectedMin
                  ? filters[activeId].selectedMin
                  : min,
                filters[activeId].selectedMax
                  ? filters[activeId].selectedMax
                  : max,
              ]}
              onAfterChange={(value) => selected(value, 'balance')}
              data-test = "balance-after-input"
              key={'balance'}
            />
          )}
        </SliderComponent>
        <MinMaxWrap>
          <Input
            onChange={(value) => selected(value, 'balance', 'min')}
            data-test = "balance-input"
            step={1}
            defaultValue={
              filters[activeId].selectedMin
                ? filters[activeId].selectedMin
                : min
            }
            value={filters[activeId].minInputValue}
            min={min}
            max={max}
          />
          <Input
            onChange={(value) => selected(value, 'balance', 'max')}
            data-test = "balance-input-two"
            step={1}
            defaultValue={
              filters[activeId].selectedMax
                ? filters[activeId].selectedMax
                : max
            }
            value={filters[activeId].maxInputValue}
            min={min}
            max={max}
          />
        </MinMaxWrap>
      </React.Fragment>
    );
  } else if (activeFilter === 'Year Opened') {
    let min =
      filters[activeId].minRange !== -1
        ? Number(moment(filters[activeId].minRange).format('YYYY'))
        : filters[activeId].minRange;
    let max = Number(moment(filters[activeId].maxRange).format('YYYY'));
    return (
      <React.Fragment>
        <SliderComponent disabled={min === -1}>
          {min === -1 ? (
            <Slider
              range
              min={min}
              max={max}
              tooltipVisible={false}
              disabled={min === -1}
              defaultValue={[
                filters[activeId].selectedMin
                  ? filters[activeId].selectedMin
                  : min,
                filters[activeId].selectedMax
                  ? filters[activeId].selectedMax
                  : max,
              ]}
              onAfterChange={(value) => selected(value, 'year')}
              key={'year'}
            />
          ) : (
            <Slider
              range
              min={min}
              max={max}
              step={1}
              disabled={min === -1}
              defaultValue={[
                filters[activeId].selectedMin
                  ? filters[activeId].selectedMin
                  : min,
                filters[activeId].selectedMax
                  ? filters[activeId].selectedMax
                  : max,
              ]}
              onAfterChange={(value) => selected(value, 'year')}
              key={'year'}
            />
          )}
        </SliderComponent>
        <MinMaxWrap>
          <Input
            noForamtter
            step={1}
            data-test = "year-opened-min"
            onChange={(value) => selected(value, 'year', 'min')}
            defaultValue={
              filters[activeId].selectedMin
                ? filters[activeId].selectedMin
                : min
            }
            value={Number(
              moment(filters[activeId].minInputValue).format('YYYY')
            )}
            min={min}
            max={max}
          />
          <Input
            noForamtter
            step={1}
            data-test = "year-opened-max"
            onChange={(value) => selected(value, 'year', 'max')}
            defaultValue={
              filters[activeId].selectedMax
                ? filters[activeId].selectedMax
                : max
            }
            value={Number(
              moment(filters[activeId].maxInputValue).format('YYYY')
            )}
            min={min}
            max={max}
          />
        </MinMaxWrap>
      </React.Fragment>
    );
  } else if (activeFilter === 'States') {
    let options = [];
    options.push({
      key: 'select',
      value: '--select--',
    });
    filters[activeId].choices.forEach((opt) => {
      options.push({
        key: opt,
        value: opt,
      });
    });
    return (
      <>
        <MultiSelect
          stateModal={true}
          filterModal={true}
          filterSelect={true}
          options={options}
          defaultValue={'select'}
          mode='multiple'
          showArrow={true}
          sorted={(value) => selected(value, 'states')}
          value={filters[activeId].selectedVal}
        />
      </>
    );
  } else if (activeFilter === 'Designated Role') {
    let options = [];
    options.push({
      key: 'select',
      value: '--select--',
    });
    filters[activeId].choices.forEach((opt) => {
      options.push({
        key: opt,
        value: opt,
      });
    });
    return (
      <React.Fragment>
        <MultiSelect
          filterModal={true}
          filterSelect={true}
          options={options}
          defaultValue={'select'}
          value={filters[activeId].selectedVal}
          sorted={(value) => selected(value, 'roles')}
        />
      </React.Fragment>
    );
  }
}

function createReset(activeFilter, filters, reset) {
  const selectedFilter = filters.findIndex((ele) => {
    return ele.type === activeFilter;
  });
  return (
    <ResetLink
      onClick={() =>
        reset(filters[selectedFilter], activeFilter, selectedFilter)
      }
      data-test = "reset-link"
    >
      Reset
    </ResetLink>
  );
}
class FilterModal extends Component {
  render() {
    const { selected, reset, typed } = this.props;
    let activeFilter = null;
    let activeId = null;
    for (let itr = 0; itr < this.props.filters.length; itr++) {
      if (this.props.filters[itr].popup === true) {
        activeFilter = this.props.filters[itr].type;
        activeId = itr;
        break;
      }
    }
    if (activeFilter === null) return null;
    let generteModal = createModal(
      this.props.filters,
      activeFilter,
      activeId,
      selected,
      typed
    );
    let generateReset = createReset(activeFilter, this.props.filters, reset);
    return (
      <ModaWrapper
        left={this.props.filters[activeId].web}
        className='filter-wrapper'
      >
        <FilterTriangle
          right={
            activeFilter === 'Balance' || activeFilter === 'Year Opened'
              ? false
              : true
          }
        />
        <TitleGrid>
          <FilterType>{activeFilter}</FilterType>
          {generateReset}
        </TitleGrid>
        {generteModal}
        <BottomWrapper>
          <CloseText key='closeText' onClick={this.props.closed}>
            Close <Icon type='close' />
          </CloseText>
        </BottomWrapper>
      </ModaWrapper>
    );
  }
}
FilterModal.propTypes = {
  closed: PropTypes.func,
  filters: PropTypes.arrayOf(PropTypes.object),
  reset: PropTypes.func,
  selected: PropTypes.func,
};
export default FilterModal;
